var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPulseFaqQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9003 20.0667C14.9003 20.5822 14.4824 21 13.967 21C13.4515 21 13.0337 20.5822 13.0337 20.0667C13.0337 19.5513 13.4515 19.1335 13.967 19.1335C14.4824 19.1335 14.9003 19.5513 14.9003 20.0667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9667 17.0335C13.5803 17.0335 13.2667 16.7199 13.2667 16.3335V15.3908C13.2667 14.5023 13.8305 13.7061 14.6686 13.4103C15.7839 13.0174 16.5335 11.8291 16.5335 10.9667C16.5335 9.55084 15.3826 8.4 13.9667 8.4C12.5508 8.4 11.4 9.55084 11.4 10.9667C11.4 11.3531 11.0864 11.6667 10.7 11.6667C10.3136 11.6667 10 11.3531 10 10.9667C10 8.77991 11.7791 7 13.9667 7C16.1544 7 17.9335 8.77991 17.9335 10.9667C17.9335 12.5236 16.7042 14.1766 15.1343 14.731C14.8544 14.8289 14.6667 15.0948 14.6667 15.3917V16.3335C14.6667 16.7199 14.3531 17.0335 13.9667 17.0335Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseFaqQuestionMark);
export default __webpack_public_path__ + "static/media/pulse-faq-question-mark.96a9fe281c81358afb15446c6ca5503b.svg";
export { ForwardRef as ReactComponent };